import Detail from '../../../../components/Detail';
import InfoPopUp from '../../../../components/InfoPopUp';
import { formatUSD } from '../../../../helpers/formats';
import useUserStatistics from '../../../../hooks/web3/vault/useUserStatistics';

const ReadyToWithdraw: React.FC = () => {
    const { userStatistics } = useUserStatistics();

    const ready = userStatistics
        ? Object.entries(userStatistics.spools).filter(
              ([_, { userWithdrawableBalance }]) => userWithdrawableBalance !== 0
          )
        : [];

    return (
        <Detail
            title={
                <>
                    <span>Ready to withdraw</span>
                    <InfoPopUp>
                        <span>Ready to Withdraw:</span>
                        {ready.length ? (
                            ready.map(
                                ([
                                    spoolAddress,
                                    { userWithdrawableBalance, spoolDetails },
                                ]) => (
                                    <div className='mt' key={spoolAddress}>
                                        <span className='block'>
                                            {spoolDetails?.spoolName ?? 'Spool'}
                                        </span>
                                        <strong className='block'>
                                            {formatUSD(userWithdrawableBalance || 0)}{' '}
                                            {spoolDetails?.underlying?.symbol ?? 'Asset'}
                                        </strong>
                                    </div>
                                )
                            )
                        ) : (
                            <strong className='block'>N/A</strong>
                        )}
                    </InfoPopUp>
                </>
            }
            value={`$${formatUSD(userStatistics?.total?.userWithdrawableBalance || 0)}`}
        />
    );
};

export default ReadyToWithdraw;
